import React from "react";
import "../css/accommodationCard.css";

function AccommodationCard({ name, location, description, image }) {
  return (
    <div className="card accommodation-card h-100">
      <img src={image} className="card-img-top" alt={name} />
      <div className="card-body">
        <h5 className="card-title">{name}</h5>
        <p className="card-text">{location}</p>
        
        <p className="card-text">{description}</p>
      </div>
    </div>
  );
}

export default AccommodationCard;
